import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

/**
 *  Renders a leave in detail
 * @param {any} item An object containing leave props
 */
function LeaveDetail({ item, onEdit }) {
    return (
        <>
            {item.leave_outcome ? <span className="badge badge-primary">Returned</span> : <span className="badge badge-danger">Pending Return</span>}
            <div className="row">
                <div className="col-3 bg-primary text-center">Leave Status</div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Status</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.status}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Leave Type </strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.type.name}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Has this Leave Authorization been read*</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.authorized ? "Yes" : "No"}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Staff</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                <StaffProfileCard item={item.author} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">Going out on leave</div>
                <div className="col-12">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Date Out</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {cleanDate(item.datetime_out)}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Escorts</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    <ol>
                                        {item.escorts.map((e, i) => (
                                            <li key={i}>
                                                <StaffProfileCard item={e} />
                                            </li>
                                        ))}
                                    </ol>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Venue</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.venue}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Is the patient's photo up to date?</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.photo_updated ? "Yes" : "No"}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Clothing Description</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.clothing_desc}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Has the patients presentation / mental state has been assessed prior to existing the ward?</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.been_accessed ? "Yes" : "No"}
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Mental state Assessment Details</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.mental_state_assessment_detail}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Returning from leave</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <strong>if patient requires a rub down, please complete a personal search form</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Return Status</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.leave_outcome ? <span className="badge badge-primary">Returned</span> : <span className="badge badge-danger">Pending Return</span>}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Date Back</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {cleanDate(item.return_datetime)}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Evaluate Leave</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.evaulate_leave}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Contingency Plan</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Contact Telephone Number</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.contact_tel_number}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Agreed Plan and Actions</strong>
                            </td>
                            <td style={{ width: "60%" }} className="text-primary">
                                {item.plan_action}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Leave Result</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        {item.evaulate_leave && (
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Leave Evaluation</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.evaulate_leave}
                                </td>
                            </tr>
                        )}
                        {item.leave_outcome && (
                            <tr>
                                <td style={{ width: "40%" }}>
                                    <strong>Leave Outcome</strong>
                                </td>
                                <td style={{ width: "60%" }} className="text-primary">
                                    {item.leave_outcome}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="col-md-12 m-t-20">
                    <div className="text-right">
                        <button onClick={() => onEdit(item)} type="button" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                            Update <i className="material-icons">keyboard_arrow_right</i>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LeaveDetail;
